<template>
  <div class="container">
    <div class="minu" id="jump0">
      <div class="head">
        <div class="headLogo" @click="$router.push('/')">
          <img class="headLogo_img" src="../../static/img/logo.png" alt="" />
          <div class="headLogo_title">Быстрые займы.kz</div>
        </div>
        <div class="headMinu">
          <div class="headAbout">
            <div :class="index == 1 ? 'headAbout_text' : 'headAbout_textTwo'" @click="goFn(1)">О нас</div>
            <div :class="index == 2 ? 'headAbout_text' : 'headAbout_textTwo'" @click="goFn(2)">Как его получить?</div>
          </div>
          <div class="headLang">
            <div class="headLang_e">QZ</div>
            <div class="headLang_h">RU</div>
          </div>
          <div class="head_btn" @click="getlogin">Bойти</div>
        </div>
      </div>
    </div>

    <!-- 描述  -->
    <div class="introduce">
      <div class="introduce_title">документ</div>
      <div class="introduce_text">Важные документы</div>
    </div>

    <!-- 内容 -->
    <div class="cont">
      <div class="cont_title">документ</div>
      <div class="cont_mi">
        <!-- 协议 -->
        <div class="">
          <div class="protocol_text" @click="privacyFn">Политика конфиденциальности</div>
          <div class="protocol_text" @click="AgreementFn">Пользовательское соглашение</div>
          <div class="protocol_text" @click="documentFn">Документы ТОО «МФО «ECKZ»</div>
          <div class="protocol_text" @click="creditagreementFn">Правила предоставления микрокредита</div>
          <div class="protocol_text" @click="ruleFn">Договор на предоставление микрокредита</div>
          <div class="protocol_text" @click="Voluntary">Правила добровольного онлайн-страхования</div>
          <div class="protocol_text" @click="lifeInsurancefn">Правила добровольного онлайн страхования жизни</div>
        </div>
        <!-- 额度 -->
        <div class="cont_loan">
          <div class="cont_loan-title">Доступная сумма кредита</div>
          <div class="loan">
            <img class="cont_loan-img" src="../../static/img/js.png" alt="" @click="getreduce" />
            <div>
              <span class="cont_loan-num">{{unitConverter(loannum)}}</span>
              <span class="cont_loan-text">〒</span>
            </div>
            <img class="cont_loan-img" src="../../static/img/zj.png" alt="" @click="getadd" />
          </div>
          <div class="content_mi-btn" @click="getlogin">Получить {{unitConverter(loannum)}} 〒</div>
          <div class="content_mi-text">*В зависимости от срока и сyммы микрокредита</div>
          <div class="content_mi-bom">
            <div class="content_mi-bom-text">Сумма к погашению</div>
            <div class="content_mi-bom-text">{{unitConverter(Interest)}} 〒</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="bom">
      <div class="bom_title">Наши Контакты</div>
      <img class="bom_bg" src="../../static/img/d.png" alt="" />
      <div style="display: flex;justify-content: space-between;">
        <div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/tel.png" alt="" />
            <div class="bom_min-text">+7 775 030 8686</div>
          </div>
          <!-- <div class="bom_min" @click="wafn">
            <img class="bom_min-img" src="../../static/img/wa.png" alt="" />
            <div class="bom_min-text">+{{WhatsAppphone}}</div>
          </div> -->
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/time.png" alt="" />
            <div class="bom_text">Пн-Пт 10:00-19:00 Сб, Вс выходные</div>
          </div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/email.png" alt="" />
            <div class="bom_min-text-two">Support@fcredit.kz</div>
          </div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/add.png" alt="" />
            <div class="bom_min-two">Казахстан, город Алматы, Бостандыкский район, улица Еділ Ерғожин, здание 27, 46</div>
          </div>
        </div>

        <div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;margin-top: 0.08rem;" @click="$router.push('/')">Главная страница</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="goFn(1)">О нас</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="goFn(2)">Как его получить?</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="homeFn(0)">документ</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="goFn(3)">Страховка</div>
        </div>

        <div>
          <div class="bom_text-two">Скачивай мобильное приложение через:</div>
          <div class="bomIMg" style="margin-bottom: 0.25rem">
            <img class="bom_img" style="margin-right: 0.1rem;" src="../../static/img/googleplay.png" alt="" @click="googleFn" />
            <img class="bom_img" src="../../static/img/AppStore.png" alt=""  @click="appstoreFn" />
          </div>
          <div class="payment_minu">
            <img class="payment_minu-img" style="margin-right: 0.1rem;" src="/static/img/mastercar.png" alt="" />
            <img class="payment_minu-img" src="/static/img/visa.png" alt="" />
          </div>
        </div>
      </div>
      <div class="iua">
        <img class="iua_q" @click="getwa" src="/static/img/waapp.png" alt="" />
      </div>
    <!-- 支付相关 -->
    <div class="payment">
        <div class="payment-line"></div>
        <div class="payment_text">ТОО «МФО ECKZ», Лицензия на осуществление микрофинансовой деятельности № 02.24.0011.М, от 12.09.2024 года,
          выдана Управлением региональных представителей в городе Алматы Агентства Республики Казахстан по регулированию
          и развитию финансового рынка.</div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import {
    userStepData,
    cfgIndex
  } from '@/api/info'
  export default {
    name: "document",
    data() {
      return {
        index: 0,
        loannum: 165000,//借款金额
        Interest: 0,//利息
        whatsappArr: '77476509659',
        WhatsAppphone: ''
      };
    },
    created() {
      this.cfgIndexfn()
      if(this.loannum != 0) {
        this.Interest = this.loannum * 1.0001
      }
    },
    methods: {
      // 获取全局配置
      cfgIndexfn(){
        cfgIndex().then(res => {
          let WhatsAppphone = res.data.data.WhatsAppphone
          this.whatsappArr = res.data.data.WhatsAppphone
          this.WhatsAppphone = WhatsAppphone.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1 $2 $3 $4');
        })
      },
      // 跳转wa
      getwa(){
        location.href = 'https://sg.sobot.com/chat/h5/v7/index.html?sysnum=01c300067aff4d1d948990845d880606'
      },
      wafn(){
        location.href = "https://api.whatsapp.com/send?phone=" + this.whatsappArr
      },
      // 金额增加
      getadd(){
        if(this.loannum == 185000) return
        this.loannum += 5000; // 每次点击增加5000
        this.Interest = this.loannum * 1.0001
      },
      // 金额减少
      getreduce(){
        if(this.loannum >= 5000 && this.loannum != 10000){
          this.loannum -= 5000
          this.Interest = this.loannum * 1.0001
        }
      },
      goFn(type) {
        this.index = type
        if (type == 1) {
          this.$router.push('/about')
        } else if(type == 2){
          this.$router.push('/tutorial')
        }else{
          this.$router.push('/Insurance')
        }
      },
      unitConverter(e){
      	if (!e) return 0
      	 // 获取整数部分
      	 const intPart = Math.trunc(e)
      	 // 整数部分处理，增加,
      	 const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      	 // 预定义小数部分
      	 let floatPart = ''
      	 // 将数值截取为小数部分和整数部分
      	 const valueArray = e.toString().split('.')
      	 if (valueArray.length === 2) { // 有小数部分
      	   floatPart = valueArray[1].toString() // 取得小数部分
      	   return intPartFormat + '.' + floatPart
      	 }
      	 return intPartFormat + floatPart
      },
      getlogin(){
        if(this.flage) return
        userStepData().then(res => {
          if(localStorage.getItem('token')){
            if(res.data.code != 0){
              this.flage = false
              if(res.data.code == 301){
                this.$router.push('/login')
              }
            }else{
              this.flage = false
              var step = res.data.data.step
              if(step >= 12){
                this.$router.push('/underreview')
              }else{
                this.$router.push('/login')
              }
            }
          }else{
            this.$router.push('/login')
          }
        })
      },
      homeFn(index) {
        if (index == 0) {
          document.querySelector("#jump" + index).scrollIntoView(true);
        }
      },
      googleFn() {
        location.href =
          'https://play.google.com/store/apps/details?id=loan.mfo.credit.tez.money.cash.zaim.pay.bank.card'
      },
      privacyFn() {
        location.href = 'https://fcredit.kz/privacy.html'
      },
      AgreementFn() {
        location.href = 'https://fcredit.kz/Agreement'
      },
      documentFn() {
        location.href = 'https://fcredit.kz/document/document.pdf'
      },
      paydocumentFn() {
        location.href = 'https://fcredit.kz/pay-document'
      },
      ruleFn() {
        location.href = 'https://fcredit.kz/contract.pdf'
      },
      Voluntary(){
        location.href = 'https://fcredit.kz/Voluntaryrules.pdf'
      },
      lifeInsurancefn(){
        location.href = 'https://fcredit.kz/lifeInsurance.pdf'
      },
      creditagreementFn() {
        location.href = 'https://fcredit.kz/BasicRules.pdf'
      },
      appstoreFn() {
        location.href = 'https://h5.fcredit.kz'
        // this.$message({
        //   message: 'В стадии разработки'
        // });
      }
    },
  };
</script>

<style scoped>
  .head {
    padding: 0.1rem 1.88rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .headLogo {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .headLogo_img {
    width: 0.25rem;
    height: 0.19rem;
    margin-right: 0.07rem;
  }

  .headLogo_title {
    width: 0.41rem;
    height: 0.19rem;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.08rem;
    color: #0aba08;
    font-style: normal;
    cursor: pointer;
  }

  .headMinu {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .headAbout {
    width: 1.48rem;
    height: 0.23rem;
    line-height: 0.23rem;
    border-radius: 0.11rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.27rem;
    margin-right: 0.45rem;
  }

  .headAbout_text {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #333333;
    font-style: normal;
    cursor: pointer;
  }

  .headAbout_textTwo {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #999999;
    font-style: normal;
    cursor: pointer;
  }

  .headAbout_textTwo:hover {
    color: #06B804;
    cursor: pointer;
  }

  .headLang {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 0.29rem;
  }

  .headLang_e {
    width: 0.17rem;
    height: 0.17rem;
    line-height: 0.17rem;
    border-radius: 0.02rem;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #fff;
    font-style: normal;
    margin-right: 0.07rem;
  }

  .headLang_h {
    width: 0.17rem;
    height: 0.17rem;
    line-height: 0.17rem;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #fff;
    font-style: normal;
  }

  .head_btn {
    width: 0.75rem;
    height: 0.23rem;
    line-height: 0.23rem;
    text-align: center;
    background: #0ABA08;
    border-radius: 0.03rem;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.08rem;
    color: #FFFFFF;
    font-style: normal;
    cursor: pointer;
  }

  .introduce {
    height: 1.3rem;
    background-color: #0ABA08;
    background-image: url(../../static/img/wj.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding-left: 1.88rem;
    padding-top: 0.78rem;
  }
  .introduce_title{
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.26rem;
    color: #FFFFFF;
    font-style: normal;
    margin-bottom: 0.1rem;
  }
  .introduce_text{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #CDF0CC;
    font-style: normal;
  }

  .cont {
    padding: 0.54rem 1.88rem;
    background: #F6F8F8;
  }
  .cont_title{
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.22rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.25rem;
  }
  .cont_mi{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .protocol_text{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    font-style: normal;
    text-decoration-line: underline;
    margin-bottom: 0.21rem;
    cursor: pointer;
  }
  .cont_loan{
    background: #FFFFFF;
    box-shadow: 0rem 0.04rem 0.08rem 0rem rgba(9,72,9,0.1);
    border-radius: 0.14rem;
    padding: 0.26rem 0.22rem 0.21rem;
  }
  .cont_loan-title{
    font-family: SFProText, SFProText;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    font-style: normal;
    margin-bottom: 0.15rem;
    text-align: center;
  }
  .loan{
    width: 1.36rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto 0.27rem;
  }
  .cont_loan-img{
    width: 0.17rem;
    height: 0.17rem;
    cursor: pointer;
  }
  .cont_loan-num{
    font-family: SFProText, SFProText;
    font-weight: 600;
    font-size: 0.19rem;
    color: #1A1A1A;
    font-style: normal;
    margin-right: 0.02rem;
  }
  .cont_loan-text{
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.1rem;
    color: #666666;
    font-style: normal;
  }
  .content_mi-btn {
    width: 2.45rem;
    height: 0.42rem;
    line-height: 0.42rem;
    background: linear-gradient(180deg, #FFBD00 0%, #FF9100 100%);
    border-radius: 0.08rem;
    font-family: SFProText, SFProText;
    font-weight: bold;
    font-size: 0.13rem;
    color: #FFFFFF;
    text-align: center;
    font-style: normal;
    margin-bottom: 0.08rem;
    cursor: pointer;
  }
  .content_mi-btn:hover {
    background: #06B804;
    cursor: pointer;
  }
  .content_mi-text {
    font-family: SFProText, SFProText;
    font-weight: 400;
    font-size: 0.06rem;
    color: #666666;
    font-style: normal;
    margin-bottom: 0.14rem;
  }
  .content_mi-bom {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .content_mi-bom-text {
    font-family: SFProText, SFProText;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    font-style: normal;
  }
  /* 中间部分 end */
  .bom {
    padding: 0.44rem 1.96rem 0.24rem 1.88rem;
    background-color: #FFFFFF;
    position: relative;
  }
  .bom_bg{
    width: 2.6rem;
    height: 1.81rem;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .bom_title{
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.18rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.27rem;
  }
  .bom_min{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.2rem;
  }
  .bom_min-img{
    width: 0.23rem;
    height: 0.23rem;
    margin-right: 0.11rem;
  }
  .bom_min-text{
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
    cursor: pointer;
  }
  .bom_min-text-two{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
  }
  .bom_min-two{
    width: 2.17rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.09rem;
    color: #333333;
    line-height: 0.13rem;
    font-style: normal;
  }
  .bom_text {
    width: 0.88rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.09rem;
    color: #333333;
    line-height: 0.13rem;
    font-style: normal;
  }
  .bom_texte{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #06B804;
    margin-bottom: 0.09rem;
    font-style: normal;
  }

  .bom_text-two {
   width: 1.06rem;
   font-family: Roboto, Roboto;
   font-weight: 400;
   font-size: 0.09rem;
   color: #666666;
   line-height: 0.13rem;
   font-style: normal;
   margin-bottom: 0.1rem;
  }
  .bomIMg {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .bom_img {
    width: 0.71rem;
    height: 0.21rem;
    cursor: pointer;
  }

  .payment {
    padding-right: 0.5rem;
    margin-top: 0.2rem;
  }
  .payment-line{
    width: 6.24rem;
    height: 0.01rem;
    background: #E3E3E3;
    margin-bottom: 0.2rem;
  }
  .payment_text {
    width: 5.46rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.07rem;
    color: #5C5C5C;
    line-height: 0.13rem;
    font-style: normal;
  }

  .payment_minu {
    width: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .payment_minu-img {
    width: 0.49rem;
    height: 0.31rem;
  }
  .iua{
    position: absolute;
    bottom: 1.25rem;
    right: 0.325rem;
  }
  .iua_q{
    width: 0.35rem;
    height: 0.35rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/document.vue